<arm-dialog (onCancel)="onCancel()" (onSubmit)="onSubmit()" [title]="'Advanced Search'" class="prefix-group-search">
  <div class="search-container">
    <div class="search-column">

      <mat-form-field>
        <mat-label>Name</mat-label>
        <input [(ngModel)]="search.name" matInput name="name" maxlength="255">
      </mat-form-field>

      <ac-input-container label="Type">
        <ac-select [acModel]="search.type"
                   (acModelChange)="search.type = $event"
                   [items]="search.prefixTypeOptions"
                   bindLabel="text"
                   bindValue="value"
                   [allowClear]="true">
        </ac-select>
      </ac-input-container>

      <div class="search-type-option fullWidth">
        <mat-radio-group [(ngModel)]="search.searchType" [ngModelOptions]="{standalone: true}"
                         (change)="searchTypeChange($event)">
          <mat-radio-button color="primary" value="VALUE" class="fullWidth">
            <mat-form-field>
              <mat-label>Value</mat-label>
              <input [(ngModel)]="search.value" matInput name="value-any" maxlength="255"
                     [disabled]="search.searchType === 'MATCH'">
            </mat-form-field>
          </mat-radio-button>

          <mat-radio-button color="primary" value="MATCH" class="fullWidth">
            <mat-form-field>
              <mat-label>Exact Match</mat-label>
              <input [(ngModel)]="search.match" matInput name="value-exact" maxlength="255"
                     [disabled]="search.searchType === 'VALUE'">
            </mat-form-field>
          </mat-radio-button>
        </mat-radio-group>
      </div>


    </div>

  </div>
</arm-dialog>


